import { PropTypes } from "prop-types"

import Translate from "../Translate"

function BannerLink(props) {
  const { link, isAccessible = true } = props
  const accessibilitySuffix = isAccessible
    ? "accessAccessibleLinkOpensInNewTab"
    : "accessNonAccessibleLinkOpensInNewTab"

  if (!link) {
    return null
  }

  return (
    <Translate>
      {({ translate }) => (
        <div className="oj-banner-link">
          <a target="_blank" href={link} rel="noopener noreferrer">
            <div
              className="banner-image"
              role="img"
              aria-label={translate("bannerLinkImageAltText")}
            />
            <span className="accessibility-tag">
              <Translate id={accessibilitySuffix} />
            </span>
          </a>
        </div>
      )}
    </Translate>
  )
}

BannerLink.propTypes = {
  link: PropTypes.string,
  isAccessible: PropTypes.bool
}

BannerLink.displayName = "BannerLink"

export default BannerLink
